"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Multiselect = void 0;
var mobx_react_1 = require("mobx-react");
var React = require("react");
var typestyle_1 = require("typestyle");
var config_1 = require("../../config");
var Multiselect = (function (_super) {
    __extends(Multiselect, _super);
    function Multiselect(props) {
        var _this = _super.call(this, props) || this;
        _this.selectRef = null;
        _this.hasChoices = function () { return _this.props.choices.length > 0; };
        _this.state = {
            value: props.value.map(function (x) { return x.toString(); }),
            unchecked: props.unchecked ? props.unchecked.map(function (x) { return x.toString(); }) : []
        };
        return _this;
    }
    Multiselect.prototype.componentWillReceiveProps = function (nextProps) {
        this.setStateFromProps(nextProps);
    };
    Multiselect.prototype.componentDidMount = function () {
        this.createMultiselect();
        return false;
    };
    Multiselect.prototype.componentDidUpdate = function () {
        this.createMultiselect();
        return false;
    };
    Multiselect.prototype.setStateFromProps = function (props) {
        this.setState({
            value: props.value.map(function (x) { return x.toString(); }),
            unchecked: props.unchecked ? props.unchecked.map(function (x) { return x.toString(); }) : []
        });
        G$(this.selectRef).multiselect('rebuild');
        G$(this.selectRef).multiselect('refresh');
    };
    Multiselect.prototype.createMultiselect = function () {
        var self = this;
        var opts = {
            onChange: function (option, checked) {
                var checked_values = self.state.value.slice();
                var unchecked_values = self.state.unchecked.slice();
                var value = option[0].value;
                var checkedIndex = checked_values.indexOf(value);
                var uncheckedIndex = unchecked_values.indexOf(value);
                if (self.props.enable_indeterminate && checkedIndex == -1 && uncheckedIndex == -1) {
                    unchecked_values.push(value);
                    uncheckedIndex = unchecked_values.length - 1;
                }
                if (checked) {
                    if (checkedIndex == -1)
                        checked_values.push(value);
                    if (uncheckedIndex >= 0)
                        unchecked_values.splice(uncheckedIndex, 1);
                }
                else {
                    if (uncheckedIndex == -1)
                        unchecked_values.push(value);
                    if (checkedIndex >= 0)
                        checked_values.splice(checkedIndex, 1);
                }
                self.setState({
                    value: checked_values,
                    unchecked: unchecked_values
                });
                self.props.onSingleChange && self.props.onSingleChange(value, checked);
                self.props.onChange && self.props.onChange(self.state.value, self.state.unchecked);
                var event = {
                    currentTarget: {
                        name: self.props.name,
                        value: checked_values
                    }
                };
                self.props.onChangeEvent && self.props.onChangeEvent(event);
            },
            onSelectAll: function () {
                var values = self.props.choices.map(function (choice) { return choice.value; });
                self.setState({
                    value: values,
                    unchecked: []
                });
                self.props.onCheckAll && self.props.onCheckAll();
                self.props.onChange && self.props.onChange(values, []);
                var event = {
                    currentTarget: {
                        name: self.props.name,
                        value: values
                    }
                };
                self.props.onChangeEvent && self.props.onChangeEvent(event);
            },
            onDeselectAll: function () {
                var values = self.props.choices.map(function (choice) { return choice.value; });
                self.setState({
                    value: [],
                    unchecked: values
                });
                self.props.onUncheckAll && self.props.onUncheckAll();
                self.props.onChange && self.props.onChange([], values);
                var event = {
                    currentTarget: {
                        name: self.props.name,
                        value: []
                    }
                };
                self.props.onChangeEvent && self.props.onChangeEvent(event);
            },
            onDropdownHidden: function () {
                self.props.onClose && self.props.onClose();
            }
        };
        if (this.props.classes)
            opts.classes = this.props.classes;
        if (this.props.selectedText !== undefined)
            opts.nSelectedText = this.props.selectedText;
        if (this.props.numberDisplayed == 0)
            opts.numberDisplayed = this.props.numberDisplayed;
        if (this.props.noneSelectedText !== undefined)
            opts.nonSelectedText = this.props.noneSelectedText;
        if (this.props.enableHTML)
            opts.enableHTML = true;
        if (this.props.buttonContainerClass !== undefined)
            opts.buttonContainer = '<div class="dropdown ' + this.props.buttonContainerClass + '" />';
        G$(self.selectRef).multiselect(opts);
        G$(this.selectRef).multiselect('rebuild');
        G$(this.selectRef).multiselect('refresh');
    };
    Multiselect.prototype.render = function () {
        var _this = this;
        var self = this;
        var props = this.props;
        var options = ((0, config_1.groupBy)(props.choices, function (c) { return c.group_name || ""; })
            .map(function (group, index) {
            if (group.key)
                return (React.createElement("optgroup", { label: group.key, key: "r-" + index }, group.members.map(function (choice, memberKey) {
                    return React.createElement("option", { key: index + "-0-" + memberKey, value: choice.value.toString(), selected: self.state.value.indexOf(choice.value) > -1, "data-indeterminate": self.props.enable_indeterminate && self.state.value.indexOf(choice.value) == -1 && self.state.unchecked.indexOf(choice.value) == -1, dangerouslySetInnerHTML: self.props.enableHTML ? { __html: choice.html } : null, "data-title": choice.display_name }, self.props.enableHTML ? null : choice.display_name);
                })));
            else
                return (React.createElement(React.Fragment, null, group.members.map(function (choice, memberkey) {
                    return React.createElement("option", { key: index + "-1-" + memberkey, value: choice.value.toString(), selected: self.state.value.indexOf(choice.value) > -1, "data-indeterminate": self.props.enable_indeterminate && self.state.value.indexOf(choice.value) == -1 && self.state.unchecked.indexOf(choice.value) == -1, dangerouslySetInnerHTML: self.props.enableHTML ? { __html: choice.html } : null, "data-title": choice.display_name }, self.props.enableHTML ? null : choice.display_name);
                })));
        }));
        var baseClass = "Multiselect";
        return (React.createElement("div", { className: (0, typestyle_1.classes)(baseClass, self.props.classes) },
            React.createElement("select", { id: self.props.id, name: self.props.name, ref: function (select) { return _this.selectRef = select; }, className: "form-control", multiple: !self.props.single_mode, value: self.state.value, defaultValue: self.props.choices.map(function (c) { return c.value.toString(); }) }, options)));
    };
    Multiselect = __decorate([
        mobx_react_1.observer
    ], Multiselect);
    return Multiselect;
}(React.Component));
exports.Multiselect = Multiselect;
